import axios from "axios";
import { makeUrl, getItem } from "../../app/common/util/genericUtils";

const authHeaders = () => {
  const user = getItem("suprolUser");
  return {
    Authorization: `Token ${user.auth_token}`,
    "Content-Type": "application/json",
  };
};

export const triggerWhatsappNotificationApiCall = (data) => {
  return axios({
    method: "POST",
    url: makeUrl("/notification/trigger/whatsapp"),
    data,
    headers: authHeaders(),
  });
};
